var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-wrap"},[_c('van-icon',{attrs:{"name":"checked","size":"100px","color":"#66bb6a"}}),_c('p',[_vm._v("您的融资需求已提交")]),_c('p',[_vm._v("请耐心等候融资顾问与您联系")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }